/* Number ops */

import Storage from "./storage.service";
import HTTP from "./http.service";
import Settings from "./settings.service";
import {getCurrentProduct} from "./products.service";
import {milisecondstoMinutes, getUnitValuePairFromBytes} from "./helpers";

var Promotions = {};

Promotions.getPromotionsByPlan = plan => {
	if (plan["Promotions"] && plan["Promotions"].length) {
		return plan["Promotions"];
	} else {
		if (plan["promotions"] && plan["promotions"].length) {
			return plan["promotions"];
		} else {
			if(plan["PromotionKeys"] && plan["PromotionKeys"].length){
				return Promotions.getPromotionsByKeys(plan["PromotionKeys"]);
			} else {
				return [];
			}
		}
	}
};

Promotions.getPromotionsByKeys = keys => {
	let product = getCurrentProduct();
	let PlansbyProductCode = Storage.get("PlansbyProductCode");
	
	if(product && PlansbyProductCode){
		let promos = PlansbyProductCode[product.ProductCode]["vmo_promotions"];
		if(promos){
			return promos.filter(item => {
				return keys.indexOf(item.Key) !== -1;
			});
		}
	}
	return [];
};

Promotions.calculateUserAndPlanPromotions = (plan) => {
	// 1. Get promos from plan
	let plan_promotions = Promotions.getPromotionsByPlan(plan);

	// 2. get promos from saved plan
	let saved_promotions = [];
	if(Storage.get("saved_plan")){
		saved_promotions = Promotions.getPromotionsByPlan(Storage.get("saved_plan"));
	}

	// 3. combine Promotions
	let combined = Promotions.combinePromotions(saved_promotions, plan_promotions);

	// 4. calculte
	if(combined.length){
		return Promotions.calculateAllPromotions(combined);
	}
	return null;
}

Promotions.includesUserPromo = promotions => {
	let result = false;
	if (promotions) {
		for (let promotion of promotions) {
			if (promotion.IsUserPromo) {
				result = true;
				break;
			}
		}
	}
	return result;
};

Promotions.redeemPromo = (code, emiratesIdNumber = null) => {
	let config = {
		method: "post",
		url: "/promotions/redeem",
		data: {
			promo_code: code
		}
	};
	if (emiratesIdNumber) {
		config.data.ID_Number = emiratesIdNumber;
	}
	return HTTP(config);
};

Promotions.validateReward = promo_code => {
	let config = {
		method: "post",
		url: "/promotions/validate_reward",
		data: {
			promo_code: promo_code
		}
	};
	return HTTP(config);
};

Promotions.cancelPromotions = () => {
	let config = {
		method: "delete",
		url: "/promotions/cancel",
	};
	return HTTP(config);
};

Promotions.combinePromotions = (saved_promotions, plan_promotions) => {
	let all_promotions = [];

	let ids = [];

	for (let promo of plan_promotions) {
		ids.push(promo.ID);
		all_promotions.push(promo);
	}

	if (saved_promotions) {
		for (let promo of saved_promotions) {
			if (promo.IsUserPromo && ids.indexOf(promo.ID) === -1) {
				all_promotions.push(promo);
			}
		}
	}

	return all_promotions;
};

Promotions.calculateAllPromotions = (promotions) => {
	let promo = {};

	promo["extraData"] = 0;
	promo["extraLocal"] = 0;
	promo["extraInternational"] = 0;

	promo["addons"] = [];

	promo["deductions"] = [];

	for (let promotion of promotions) {

		let type = promotion.Category;

		if(type === "AmountDiscount" || type === "PercentageDiscount"){
			promo["deductions"].push(promotion);
		}

		if (type === "AddOn") {
			promo["addons"].push(promotion.Type);
		}

		if (Settings.enable_cashback_promo_type && type === "CashBack") {
			promo["cashback"] = promotion["Value"];
		}

		if (type === "RecurringData" || type === "MGM") {
			promo["extraData"] += promotion.Value;
		}

		if (promotion.Plan) {
			if (promotion.Plan.Type === "DATA") {
				promo["extraData"] += promotion.Plan["Value"];
			}
			if (promotion.Plan.Type === "VOICE-LCL") {
				promo["extraLocal"] += promotion.Plan["Value"];
			}
			if (promotion.Plan.Type === "VOICE-INT") {
				promo["extraInternational"] += promotion.Plan["Value"];
			}
		}
	}

	let pair = getUnitValuePairFromBytes(promo["extraData"]);
	promo["extraDataFormatted"] = pair['value'];
	promo["extraDataUnit"] = pair['unit'];
	promo["extraLocalFormatted"] = milisecondstoMinutes(
		promo["extraLocal"]
	);
	promo["extraInternationalFormatted"] = milisecondstoMinutes(
		promo["extraInternational"]
	);

	return promo;
};

Promotions.isEntertainerEnabled = (plan) => {
	let config = Storage.get("businessConfig");
	let isDataOnlyPlan = plan?.PackageEligibility?.includes("DataSimOnly");
	return config?.enable_entertainer && !isDataOnlyPlan;
}

Promotions.isBotimEnabled = (plan) => {
	let isBotimEnabled = false
	if (Array.isArray(plan?.PromotionKeys) && plan?.PromotionKeys.every(item => typeof item === 'string')) {
		isBotimEnabled = plan?.PromotionKeys.includes("3");
	} else {
		isBotimEnabled = plan?.Promotions.some(promo => promo.Type === "VOIPDiscount")
	}
return isBotimEnabled
}

export default Promotions;
